var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14C24 14.1064 23.9917 14.2108 23.9757 14.3127C26.7063 15.1791 29 17.7619 29 21V26L31 29.3158V32H24.8293C24.4175 33.1652 23.3062 34 22 34C20.6938 34 19.5825 33.1652 19.1707 32H13V29.3158L15 26V21C15 17.7619 17.2937 15.1791 20.0243 14.3127C20.0083 14.2108 20 14.1064 20 14C20 12.8954 20.8954 12 22 12C23.1046 12 24 12.8954 24 14ZM17 21C17 18.1954 19.5115 16 22 16C24.4885 16 27 18.1954 27 21V26.5565L29 29.8723V30H15V29.8723L17 26.5565V21Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82926 15.8764C6.05691 19.1772 6.05692 24.823 9.82926 28.1238L9.17075 28.8764C4.94308 25.1772 4.94308 18.823 9.17075 15.1238L9.82926 15.8764Z",
    fill: "#00A88E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 22C9.875 20.6437 10.2837 19.3145 11.0528 17.7764L11.9472 18.2236C11.2163 19.6854 10.875 20.8563 10.875 22C10.875 23.1437 11.2163 24.3145 11.9472 25.7764L11.0528 26.2236C10.2837 24.6854 9.875 23.3563 9.875 22Z",
    fill: "#00A88E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1707 15.8764C37.9431 19.1772 37.9431 24.823 34.1707 28.1238L34.8292 28.8764C39.0569 25.1772 39.0569 18.823 34.8292 15.1238L34.1707 15.8764Z",
    fill: "#00A88E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.125 22C34.125 20.6437 33.7163 19.3145 32.9472 17.7764L32.0528 18.2236C32.7837 19.6854 33.125 20.8563 33.125 22C33.125 23.1437 32.7837 24.3145 32.0528 25.7764L32.9472 26.2236C33.7163 24.6854 34.125 23.3563 34.125 22Z",
    fill: "#00A88E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.4ca92635b884668d68e6251dc82a3fae.svg";
export { ForwardRef as ReactComponent };